// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'

import router from './router'
import store from '@/vuex'
import http from '@/lib/admin/http'

// Vue.config.productionTip = false;

Vue.config.productionTip = false

Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  if (to.name == 'Login') {
    next();
    return;
  }

  store.dispatch('initAdmin')
    .then(async () => {
      if (!store.getters.getLoginStatus || store.getters.getLoginStatus == 'null' || store.getters.getLoginStatus == '') {
        this.$router.push({name: 'Login'});
      } else {
        if (!store.state.adminInfo.id) {
          http.getData('/api/admin/now_admin').then((res) => {
            store.commit('setAdminInfo', res.data.data);
          }).catch(error => {
            console.log(error);
          })
        }

        if (to.name == 'Login') {
          next({name: 'Cate'});
        } else {
          next();
        }
      }

      if (!store.state.adminInfo) {
        http.getData('/api/admin/now_admin').then((res) => {
          store.commit('setAdminInfo', res.data.data);
        });
      }
    });
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  computed: {},
  beforeCreate() {
    this.$store.dispatch('initAdmin')
      .then(() => {
        if (!this.$store.getters.getLoginStatus || this.$store.getters.getLoginStatus == 'null') {
          this.$router.push({name: 'Login'});
        }
      });


  },
  created() {
    let vthis = this;
    // this.$store.watch(state => state.isLogin, isLogin => {
    //   if (!isLogin) {
    //     this.$router.push({name: 'Login'});
    //     vthis.$message.error('您需要重新登录');
    //   }
    // })
  }

});



// WEBPACK FOOTER //
// ./src/main.js